import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getDevicesReport } from '../../services/Reports';

function useGetDevicesReport(fleetId: string, query: string): UseQueryResult<any> {
  return useQuery(
    ['report-devices', fleetId, query],
    async (): Promise<any> => getDevicesReport(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: false,
      refetchInterval: false,
    },
  );
}

export default useGetDevicesReport;
